import { MAINTENANCE_COST_PER_YEAR } from './aquapodCalculations.js';

/** Coût de l'eau traitée par l'Aquapod, en €/m³ — quasi intégralement le forfait d'entretien annuel. */
export const computeTreatmentCostPerM3 = (valorizedVolume) => (valorizedVolume > 0 ? MAINTENANCE_COST_PER_YEAR / valorizedVolume : null);

/**
 * Compare le coût de l'eau traitée au prix de l'eau du réseau — c'est la première question
 * business posée par le module : est-ce rentable en exploitation, indépendamment de l'investissement ?
 * @returns {{ treatmentPricePerM3: number|null, isViable: boolean, annualSavings: number }}
 */
export const computeOpexComparison = (valorizedVolume, networkPricePerM3) => {
  const treatmentPricePerM3 = computeTreatmentCostPerM3(valorizedVolume);
  if (treatmentPricePerM3 == null) return { treatmentPricePerM3: null, isViable: false, annualSavings: 0 };

  const isViable = treatmentPricePerM3 < networkPricePerM3;
  const annualSavings = valorizedVolume * (networkPricePerM3 - treatmentPricePerM3);
  return { treatmentPricePerM3, isViable, annualSavings };
};
